import React, { ReactElement } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ArrowForwardIosSharp from '@mui/icons-material/ArrowForwardIosSharp';
import { SvgIconProps } from '@mui/material/SvgIcon';
import BentoIcon from './BentoIcon';

interface RowIconProps {
  onClick: () => void;
  id: string;
  icon?: ReactElement<SvgIconProps>;
  bentoIconName?: string;
  disabled?: boolean;
  tip?: string;
  justifyContent?: 'flex-start' | 'center' | 'flex-end';
}

export default function RowIcon({
  onClick,
  id,
  icon,
  bentoIconName,
  disabled,
  tip,
  justifyContent = 'flex-end',
}: RowIconProps) {
  const iconButton = (
    <IconButton id={id} onClick={onClick} size="small" disabled={disabled}>
      {bentoIconName ? (
        <BentoIcon name={bentoIconName} />
      ) : (
        icon || <ArrowForwardIosSharp color="primary" />
      )}
    </IconButton>
  );

  return (
    <Box display="flex" justifyContent={justifyContent} alignItems="center">
      {tip ? (
        <Tooltip title={tip}>
          <span>{iconButton}</span>
        </Tooltip>
      ) : (
        iconButton
      )}
    </Box>
  );
}
